<template>
  <div class="gift-unbook">
    <nav class="gift-unbook__back">
      <router-link :to="{ name: 'GiftList' }">&#60; seznam dárků</router-link>
    </nav>

    <div class="gift-unbook__content">
      <template v-if="!loader">
        <template v-if="!unbookCode || gift.unbookCode !== unbookCode">
          <h2>
            Pro zrušení zamluvení musíš použít odkaz, který přišel v e-mailu při zamluvení.
            Pokud již tento e-mail nemáš nebo odkaz nefunguje, tak nás kontaktuj na
            <a href="mailto:svatba@bachrony.com">svatba@bachrony.com</a>
            nebo na
            <a href="tel:728060455">728060455</a>. Omlouváme se za potíže 🤦‍♂️.
          </h2>
        </template>

        <template v-else-if="!error">
          <div v-if="!unbooked" class="gift-unbook__decision">
            <h2>Cheš opravdu zrušit zamluvení dárku {{ gift.name }}?</h2>
            <div class="gift-unbook__buttons">
              <Button @click.native="unbookGift">Ano</Button>
              <Button @click.native="$router.push({ name: 'GiftList' })" variant="grey">Ne</Button>
            </div>
          </div>

          <div v-else class="gift-unbook__result">
            <h2>Zrušení proběhlo úspěšně.</h2>
            <p>Nyní je {{ gift.name }} opět k mání.</p>
            <div class="gift-unbook__buttons">
              <Button @click.native="$router.push({ name: 'GiftList' })">Zpět na seznam dárků</Button>
            </div>
          </div>
        </template>

        <div v-else class="gift-unbook__result--error">
          <h2>{{ error }}</h2>
          <div class="gift-unbook__buttons">
            <Button @click.native="$router.push({ name: 'GiftList' })" variant="grey">Zpět na seznam dárků</Button>
          </div>
        </div>
      </template>

      <Loader v-else/>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/ui/Loader.vue';
import Button from '@/components/ui/Button.vue';
import { unbookGift, reportError, fetchGift } from '@/services';

export default {
  name: 'GiftDetail',
  components: {
    Loader,
    Button,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      unbookCode: this.$route.query.unbookCode || '',
      gift: {},
      error: '',
      loader: false,
      unbooked: false,
    };
  },
  async created() {
    this.loader = true;
    const gift = await fetchGift(this.id).catch((error) => {
      reportError(error);
      this.error = 'Něco se pokazilo. Franta už byl upozorněn a příště to naprogramuje lépe 🤪.';
    });

    if (gift && gift.unbookCode === this.unbookCode) {
      this.gift = gift;
      this.unbooked = !gift.booked;
    }
    this.loader = false;
  },
  methods: {
    async unbookGift() {
      this.loader = true;
      if (this.gift.unbookCode === this.unbookCode) {
        await unbookGift(this.id).catch((error) => {
          reportError(error);
          this.error = 'Něco se pokazilo. Franta už byl upozorněn a příště to naprogramuje lépe 🤪.';
          this.loader = false;
        }).then(() => {
          this.unbooked = true;
          this.loader = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .gift-unbook {
    padding: 0 20px;

    @media (max-width: 780px) {
      padding: 0;
    }

    &__content {
      background-color: #fff;
      display: flex;
      padding: 40px 60px;
      position: relative;
      flex-direction: column;
      align-items: center;
      border-radius: 6px;

      @media (max-width: 780px) {
        border-radius: 0;
        flex-direction: column;
      }

      @media (max-width: 464px) {
        padding: 40px 30px;
        border-radius: 0;
      }

      h2 {
        @media (max-width: 464px) {
          font-size: 1rem;
        }
      }
    }

    &__back {
      padding: 10px 0;
      font-size: 1.2rem;
      font-weight: 100;
    }

    &__buttons {
      display: flex;
      justify-content: center;
    }

    &__result {
      h2 {
        color: #28522d;
      }

      p {
        margin-bottom: 20px;
      }

      &--error {
        h2 {
          color: red;
          margin-bottom: 20px;
        }
      }
    }

    &__decision {
      h2 {
        margin-bottom: 20px;
      }
    }
  }
</style>
